import React from 'react';
import { MapPin, Mail, Phone, ArrowUp } from 'lucide-react';
import { contactInfo, navLinks } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-charcoal border-t border-slate/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6 bg-ivory/10 p-3 inline-block rounded">
              <img 
                src="/logo.png" 
                alt="Nora Gold Advisory" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-slate leading-relaxed mb-6 max-w-md">
              Building Bankable Businesses. Unlocking Sustainable Capital. Your
              trusted advisory partner for strategic business, financial, and
              investment solutions across emerging markets.
            </p>
            <div className="flex gap-4">
              <a
                href={`mailto:${contactInfo.email}`}
                className="w-10 h-10 bg-burgundy/20 flex items-center justify-center hover:bg-burgundy transition-colors duration-300"
                aria-label="Email us"
              >
                <Mail className="text-gold" size={18} />
              </a>
              <a
                href={`tel:${contactInfo.phone}`}
                className="w-10 h-10 bg-burgundy/20 flex items-center justify-center hover:bg-burgundy transition-colors duration-300"
                aria-label="Call us"
              >
                <Phone className="text-gold" size={18} />
              </a>
              <div
                className="w-10 h-10 bg-burgundy/20 flex items-center justify-center"
                aria-label="Location"
              >
                <MapPin className="text-gold" size={18} />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-ivory font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(link.href);
                    }}
                    className="text-slate hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-ivory font-semibold text-lg mb-6">
              Contact Info
            </h4>
            <ul className="space-y-4 text-slate">
              <li className="flex gap-3">
                <MapPin className="text-gold flex-shrink-0 mt-1" size={18} />
                <span>
                  {contactInfo.building}, {contactInfo.street},{' '}
                  {contactInfo.area}
                </span>
              </li>
              <li className="flex gap-3">
                <Mail className="text-gold flex-shrink-0" size={18} />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="hover:text-gold transition-colors"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Phone className="text-gold flex-shrink-0" size={18} />
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="hover:text-gold transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate/20 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate text-sm">
            © {new Date().getFullYear()} Nora Gold Advisory Limited. All rights
            reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="group flex items-center gap-2 text-gold text-sm hover:text-ivory transition-colors"
          >
            Back to Top
            <div className="w-8 h-8 bg-burgundy/20 flex items-center justify-center group-hover:bg-burgundy transition-colors duration-300">
              <ArrowUp size={16} />
            </div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
